
  import { Component, Watch } from 'vue-property-decorator'
  import PTitle from '@/components/config/PTitle.vue'
  import PSubtitle from '@/components/config/PSubtitle.vue'
  import { WebPageView } from '@/components/config/webPage/WebPageView'
  import { AvailableTemplate } from '@/entities/system/ConfigWebPage'

interface CustomizationOption {
  id: string;
  label: string;
  enabled: boolean;
}

interface Template extends AvailableTemplate {
  selected: boolean;
  shortDescription?: string;
  demoUrl?: string | null;
  customizationOptions?: CustomizationOption[];
}

@Component({
  components: { PTitle, PSubtitle },
})
  export default class WebTemplates extends WebPageView {
  valid: boolean = true

  availableTemplates: Template[] = [
      {
        id: 'template1',
        name: 'Moderno y Elegante',
        description: 'Un diseño contemporáneo con enfoque en la experiencia del usuario y presentación visual atractiva',
        shortDescription: 'Diseño moderno y elegante',
        thumbnail: null,
        demoUrl: null,
        features: ['Responsive', 'Minimalista', 'Animaciones suaves'],
        selected: false,
      },
      {
        id: 'template2',
        name: 'Empresarial',
        description: 'Diseño profesional y sobrio ideal para empresas que buscan proyectar seriedad y confianza',
        shortDescription: 'Diseño empresarial',
        thumbnail: null,
        demoUrl: null,
        features: ['Profesional', 'Elegante', 'Alta conversión'],
        selected: false,
      },
    ]

  get selectedTemplate (): Template | null {
    return this.availableTemplates.find(t => t.selected) || null
  }

  selectTemplate (index: number) {
    this.availableTemplates.forEach((t, i) => {
      t.selected = i === index
    })
  }

  openDemoUrl (url: string | null) {
    if (url) {
      window.open(url, '_blank')
    }
  }

  @Watch('data.templateSettings', { immediate: true, deep: true })
  onTemplateSettingsChanged (val: any) {
    if (!val) return
    // Si existe templateId en los datos guardados, seleccionar esa plantilla
    if (val?.templateId) {
      const templateIndex = this.availableTemplates.findIndex(t => t.id === val.templateId)
      if (templateIndex !== -1) {
        this.selectTemplate(templateIndex)
      } else if (this.availableTemplates.length) {
        // Si el ID guardado no se encuentra, seleccionar la primera por defecto
        this.selectTemplate(0)
      }
    } else if (this.availableTemplates.length) {
      // Si no hay templateId guardado, seleccionar la primera por defecto
      this.selectTemplate(0)
    }
  }

  async save () {
    if (!this.$refs.form.validate()) {
      return
    }

    if (!this.selectedTemplate) {
      return
    }

    // Objeto a guardar - solo guardamos el ID de la plantilla seleccionada
    const templateSettings = {
      templateId: this.selectedTemplate.id,
    }

    // Obtener la configuración actual
    const system = await this.fetchData({
      query: { name: 'fetchSpecial', model: 'Person', params: { id: this.systemId } },
      force: true,
    })

    // Guardar en el endpoint siguiendo el patrón de los otros componentes
    await this.pushData({
      model: 'Person',
      fields: {
        id: this.systemId,
        config_web_page: {
          ...system.configWebPage,
          templateSettings,
        },
      },
    })

    // Emitir evento de actualización
    this.$emit('update')
  }
  }
